<template>
  <div class="Node9Settings lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="Node9Settings-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="Node9Settings-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.Node2Settings_title1}}
        </template>
        <template v-slot:body>
          <div class="Node9Settings-wrapper-colors lxn-w100">
            <div @click="activeBoxIndex = 0;" class="Node9Settings-color color1 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(0)" :class="isBoxActive(0)">
              <div class="Node9Settings-selectedColor lxn-w100 lxn-h100 lxn-border-round">
              </div>
            </div>
            <div @click="activeBoxIndex = 1;" class="Node9Settings-color color2 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(1)" :class="isBoxActive(1)">
              <div class="Node9Settings-selectedColor lxn-w100 lxn-h100 lxn-border-round">
              </div>
            </div>
            <div @click="activeBoxIndex = 2;" class="Node9Settings-color color3 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(2)" :class="isBoxActive(2)">
              <div class="Node9Settings-selectedColor lxn-w100 lxn-h100 lxn-border-round">
              </div>
            </div>
            <div @click="activeBoxIndex = 3;" class="Node9Settings-color color4 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(3)" :class="isBoxActive(3)">
              <div class="Node9Settings-selectedColor lxn-w100 lxn-h100 lxn-border-round">
              </div>
            </div>
            <div @click="activeBoxIndex = 4;" class="Node9Settings-color color5 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(4)" :class="isBoxActive(4)">
              <div class="Node9Settings-selectedColor lxn-w100 lxn-h100 lxn-border-round">
              </div>
            </div>
          </div>
          <div class="Node9Settings-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
            {{$store.getters.language.texts.Node2Settings_text1}}
          </div>
          <div class="lxn-w100">
            <customInput @focus="inputState='active'" @blur="inputState=''" :inputState="inputState" v-model="NodeName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.AddNodeNameColor_placeHolder" inputType="text" />
          </div>
        </template>
      </TitleBox>
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.Node2Settings_title2}}
        </template>
        <template v-slot:body>
          <div class="Node9Settings-wrapper-deviceName lxn-w100 lxn-title lxn-text-en lxn-text-center">
            {{deviceName}}
          </div>
          <div class="Node9Settings-wrapper-status">
            <div class="Node9Settings-wrapper-status-d0 lxn-text" :class="[$store.getters.language.floatClass, $store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.Node2Settings_deviceStatus}}
            </div>
            <div class="Node9Settings-wrapper-status-d1" :class="[$store.getters.language.floatClassReverse]">
              <ButtonIcon :size="40" bgColor="#DEDEDE" :icon="connectionStatusIcon" iconColor="#1EA5DE" :padding="8" />
            </div>
            <div v-if="!isNodeOffline" class="Node9Settings-wrapper-status-d1" :class="[$store.getters.language.floatClassReverse]">
              <ButtonIcon :size="40" bgColor="#DEDEDE" :icon="temperatureStatusIcon" iconColor="#1EA5DE" :padding="8" />
            </div>
            <div v-if="!isNodeOffline" class="Node9Settings-wrapper-status-d1" :class="[$store.getters.language.floatClassReverse]">
              <ButtonIcon :size="40" bgColor="#DEDEDE" :icon="rssiStatusIcon" iconColor="#1EA5DE" :padding="8" />
            </div>
          </div>
          <div class="Node9Settings-wrapper-UUID lxn-w100">
            <div class="Node9Settings-wrapper-UUID-d0 lxn-title lxn-text-en" :class="$store.getters.language.floatClass">
              UUID
            </div>
            <div class="Node9Settings-wrapper-UUID-d1 lxn-title lxn-text-en" :class="$store.getters.language.floatClassReverse">
              0X{{uuid}}
            </div>
          </div>
        </template>
      </TitleBox>
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.Node9Settings_hue}}
        </template>
        <template v-slot:body>
          <div class="Node9Settings-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
            {{$store.getters.language.texts.Node9Settings_colorPickerType}}
          </div>
          <DropDown v-model="colorPickerType" :dropDownContex="dropDownColorPickerType" />
          <div style="width: 200px;margin-top: 20px;" class="lxn-margin-auto">
            <div id="lxn-color-picker"></div>
          </div>
        </template>
      </TitleBox>
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.Node9Settings_rgbw}}
        </template>
        <template v-slot:body>
          <div style="width: 200px;" class="lxn-margin-auto">
            <div class="Node9Settings-wrapper-fieldTitles lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{$store.getters.language.texts.Node9Settings_red}}
            </div>
            <div id="lxn-color-picker-r"></div>
            <div class="Node9Settings-wrapper-fieldTitles lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{$store.getters.language.texts.Node9Settings_green}}
            </div>
            <div id="lxn-color-picker-g"></div>
            <div class="Node9Settings-wrapper-fieldTitles lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{$store.getters.language.texts.Node9Settings_blue}}
            </div>
            <div id="lxn-color-picker-b"></div>
            <div class="Node9Settings-wrapper-fieldTitles lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{$store.getters.language.texts.Node9Settings_white}}
            </div>
            <div id="lxn-color-picker-w"></div>
          </div>
        </template>
      </TitleBox>
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.Node9Settings_default}}
        </template>
        <template v-slot:body>
          <div class="Node9Settings-button lxn-margin-auto lxn-w100">
            <CustomButton @click="setAsDefaultColor()" bgColor="#1EA5DE" iconRight="colorPicker" iconRightColor="#1EA5DE" iconRightBgColor="#FFFFFF" textColor="#FFFFFF" :iconRightPadding="6" :useLanguageDirection="true">
              {{$store.getters.language.texts.Node2Settings_setAsDefault}}
            </CustomButton>
          </div>
        </template>
      </TitleBox>
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.Node9Settings_animation}}
        </template>
        <template v-slot:body>
          <DropDown v-model="animationMode" :dropDownContex="dropDownAnimationMode" :disabled="isNodeOffline || isHubOffline" />
        </template>
      </TitleBox>
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.Node9Settings_fadeTime}}
        </template>
        <template v-slot:body>
          <div class="lxn-w100 lxn-overflow-hidden">
            <NumberInputSpinner :min="0" :max="65535" :step="100" :integerOnly="true" v-model="fadeTime" buttonClass="CommandCreator-commandDelay-button" />
          </div>
        </template>
      </TitleBox>
    </div>
    <div class="Node9Settings-button lxn-margin-auto lxn-w100">
      <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.Node2Settings_button}}
      </CustomButton>
    </div>
    <div v-if="isUserOwner" class="Node9Settings-button lxn-margin-auto lxn-w100">
      <CustomButton @click="deleteDevice" bgColor="#F36C4F" iconRight="arrowRight" iconRightColor="#F36C4F" iconRightBgColor="#F5C7BD" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.Node2Settings_button2}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import CustomInput from '@/components/CustomInput.vue'
import ButtonIcon from '@/components/ButtonIcon.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import NODE9 from '@/statics/devices/Node9/header.js'
import iro from '@jaames/iro';
import NumberInputSpinner from '@/components/NumberInputSpinner.vue'
import DropDown from '@/components/DropDown.vue'

export default {
  name: 'Node9Settings',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    ButtonIcon,
    NumberInputSpinner,
    DropDown
  },
  data: function () {
    var node = this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID);

    return {
      colorPicker: null,
      colorPicker_w: null,
      colorPicker_r: null,
      colorPicker_g: null,
      colorPicker_b: null,
      NodeName: node.name,
      inputState: '',
      activeBoxIndex: node.color,
      colorChangeTimeoutHandle: -1,
      debounceDelay: 100,
      color: {
        hue: 0,
        saturation: 0,
        value: 0,
        white: 0,
      },
      white: 0,
      colorLocked: false,
      fadeTime: 500,
      colorPickerType: 0,
      animationMode: 0,
    }
  },
  mounted: async function () {
    this.$store.commit('setAppBusy', true);
    var messagingHook = new Messaging(new Logger(false));
    messagingHook.init({
      psk: this.hub.psk,
      destinationUUID: this.hub.uuid,
      sourceUUID: this.$store.state.user.uuid
    });
    try {
      var nodeParameters = await this.$store.dispatch('readNodeParameters', {messagingHook: messagingHook,hubUUID: this.hub.uuid,nodeUUID: this.node.uuid});
      nodeParameters = nodeParameters.body.bodyContent.parameterList;
      this.$store.dispatch('processNodeParameters', {rawParameters: nodeParameters, nodeUUID: this.node.uuid});
      this.fadeTime = this.$store.getters.getParameterValue(this.node.index, NODE9.FADE_TIME.PARAMETER_ID);
      this.animationMode = this.$store.getters.getParameterValue(this.node.index, NODE9.ANIMATION_MODE.PARAMETER_ID);
      this.$store.commit('setHubStatus', {
        hubIndex: this.hub.index,
        stateUpdateEnabled: true,
      });
      this.$store.commit('setAppBusy', false);
    }
    catch (response) {
      if(response.rejectCode == 2){
        this.$store.commit('setHubStatus', {
          hubIndex: response.hubIndex,
          connectionStatus: {
            local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
          },
        });
      }
      alert(this.$store.getters.language.texts.Node9Settings_alert1);
      this.$store.commit('setAppBusy', false);
    }
    this.colorPicker = new iro.ColorPicker("#lxn-color-picker", {
      width: 200,
      borderWidth: 5,
      layout: [
        { 
          component: iro.ui.Wheel,
        },
        { 
          component: iro.ui.Slider,
        },
      ]
    });
    this.colorPicker_w = new iro.ColorPicker("#lxn-color-picker-w", {
      width: 200,
      borderWidth: 5,
      color: "#FFF",
      layout: [
        { 
          component: iro.ui.Slider,
          options: {
            sliderType: "value",
          }
        },
      ]
    });
    this.colorPicker_r = new iro.ColorPicker("#lxn-color-picker-r", {
      width: 200,
      borderWidth: 5,
      color: "#F00",
      layout: [
        { 
          component: iro.ui.Slider,
          options: {
            sliderType: "value",
          }
        },
      ]
    });
    this.colorPicker_g = new iro.ColorPicker("#lxn-color-picker-g", {
      width: 200,
      borderWidth: 5,
      color: "#0F0",
      layout: [
        { 
          component: iro.ui.Slider,
          options: {
            sliderType: "value",
          }
        },
      ]
    });
    this.colorPicker_b = new iro.ColorPicker("#lxn-color-picker-b", {
      width: 200,
      borderWidth: 5,
      color: "#00F",
      layout: [
        { 
          component: iro.ui.Slider,
          options: {
            sliderType: "value",
          }
        },
      ]
    });

    this.colorPicker.color.hsv = this.currentColor;
    this.colorPicker.on('color:change', this.onColorChange);
    
    this.colorPicker_w.color.hsv = {
      h: 0,
      s: 0,
      v: this.currentWhite,
    }
    this.colorPicker_r.color.hsv = {
      h: 0,
      s: 100,
      v: Math.floor((this.colorPicker.color.rgb.r / 255) * 100),
    }
    this.colorPicker_g.color.hsv = {
      h: 120,
      s: 100,
      v: Math.floor((this.colorPicker.color.rgb.g / 255) * 100),
    }
    this.colorPicker_b.color.hsv = {
      h: 240,
      s: 100,
      v: Math.floor((this.colorPicker.color.rgb.b / 255) * 100),
    }
    this.colorPicker_w.on('color:change', this.onColorChange_w);
    this.colorPicker_r.on('color:change', this.onColorChange_r);
    this.colorPicker_g.on('color:change', this.onColorChange_g);
    this.colorPicker_b.on('color:change', this.onColorChange_b);
  },
  destroyed: function () {
    this.$store.commit('cancelAllStateUpdates');
    if(this.colorPicker){
      this.colorPicker.off('color:change', this.onColorChange);
    }
    if(this.colorPicker_w){
      this.colorPicker_w.off('color:change', this.onColorChange_w);
    }
    if(this.colorPicker_r){
      this.colorPicker_r.off('color:change', this.onColorChange_r);
    }
    if(this.colorPicker_g){
      this.colorPicker_g.off('color:change', this.onColorChange_g);
    }
    if(this.colorPicker_b){
      this.colorPicker_b.off('color:change', this.onColorChange_b);
    }
  },
  watch: {
    colorPickerType: function (newVal) {
      switch(newVal){
        case 0:
          this.colorPicker.setOptions({
            layout: [
              { 
                component: iro.ui.Wheel,
              },
              { 
                component: iro.ui.Slider,
              },
            ]
          });
          break;
        case 1:
          this.colorPicker.setOptions({
            layout: [
              { 
                component: iro.ui.Slider,
                options: {
                  sliderType: 'hue'
                }
              },
              { 
                component: iro.ui.Box,
              },
            ]
          });
          break;
        case 2:
          this.colorPicker.setOptions({
            layout: [
              { 
                component: iro.ui.Slider,
                options: {
                  sliderType: 'kelvin'
                }
              },
              { 
                component: iro.ui.Slider,
                options: {
                  sliderType: 'value'
                }
              },
            ]
          });
          break;
      }
    },
    currentColor: function (newVal, oldVal) {
      if(JSON.stringify(newVal) !== JSON.stringify(oldVal)){
        if(this.colorPicker){
          this.colorLocked = true;
          this.colorPicker.color.hsv = newVal;
          this.colorPicker_r.color.hsv = {
            h: 0,
            s: 100,
            v: Math.floor((this.colorPicker.color.rgb.r / 255) * 100),
          }
          this.colorPicker_g.color.hsv = {
            h: 120,
            s: 100,
            v: Math.floor((this.colorPicker.color.rgb.g / 255) * 100),
          }
          this.colorPicker_b.color.hsv = {
            h: 240,
            s: 100,
            v: Math.floor((this.colorPicker.color.rgb.b / 255) * 100),
          }
          this.colorLocked = false;
        }
      }
    },
    currentWhite: function (newVal, oldVal) {
      if(JSON.stringify(newVal) !== JSON.stringify(oldVal)){
        if(this.colorPicker_w){
          this.colorLocked = true;
          this.colorPicker_w.color.hsv = {
            h: 0,
            s: 0,
            v: this.currentWhite,
          }
          this.colorLocked = false;
        }
      }
    },
    currentAnimationMode: function (newVal) {
      if(newVal != undefined){
        this.animationMode = newVal;
      }else{
        this.animationMode = 0;
      }
    },
    currentFadeTime: function (newVal) {
      if(newVal != undefined){
        this.fadeTime = newVal;
      }else{
        this.fadeTime = 0;
      }
    },
  },
  computed: {
    node: function () {
      return this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID);
    },
    hub: function () {
      return this.$store.getters.getHubByUUID(this.node.hubUUID);
    },
    isUserOwner: function () {
      return this.hub.isOwner;
    },
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    deviceName: function () {
      return NODE9.NAME;
    },
    uuid: function () {
      return this.node.uuid.toString(16).toUpperCase();
    },
    connectionStatusIcon: function () {
      var connectionStatusIcon = this.node.connectionStatus;
      if(connectionStatusIcon == -1 || connectionStatusIcon == 0){
        connectionStatusIcon = 'offline';
      }else{
        return 'online';
      }
      return connectionStatusIcon;
    },
    rssiStatusIcon: function () {
      var rssiParameterId = NODE9.LORA_RSSI.PARAMETER_ID;
      var snrParameterId = NODE9.LORA_SNR.PARAMETER_ID;
      var rssi = this.$store.getters.getParameterValue(this.node.index, rssiParameterId);
      var snr = this.$store.getters.getParameterValue(this.node.index, snrParameterId);

      return this.$store.getters.getNodeRssiSnrIcon(rssi, snr);
    },
    temperatureStatusIcon: function () {
      var temperatureParameterId = NODE9.TEMPERATURE.PARAMETER_ID;
      var temperature = this.$store.getters.getParameterValue(this.node.index, temperatureParameterId);

      return this.$store.getters.getNodeTemperatureIcon(temperature);
    },
    snr: function () {
      var targetParameterId = 0x8103;
      var temperatureStatus = this.$store.getters.getParameterValue(this.node.index, targetParameterId);
      return temperatureStatus;
    },
    currentAnimationMode: function () {
      var currentAnimationMode = this.$store.getters.getParameterValue(this.node.index, NODE9.ANIMATION_MODE.PARAMETER_ID);
      if(currentAnimationMode === undefined){
        currentAnimationMode = 0;
      }
      return currentAnimationMode;
    },
    currentFadeTime: function () {
      var currentFadeTime = this.$store.getters.getParameterValue(this.node.index, NODE9.FADE_TIME.PARAMETER_ID);
      if(currentFadeTime === undefined){
        currentFadeTime = 500;
      }
      return currentFadeTime;
    },
    currentColor: function () {
      var currentHue = this.$store.getters.getParameterValue(this.node.index, NODE9.HUE.PARAMETER_ID);
      var currentSaturation = this.$store.getters.getParameterValue(this.node.index, NODE9.SATURATION.PARAMETER_ID);
      var currentValue = this.$store.getters.getParameterValue(this.node.index, NODE9.BRIGHTNESS.PARAMETER_ID);
      if( currentHue !== undefined && currentSaturation !== undefined && currentValue !== undefined){
        var currentColor = {
          h: Math.floor((currentHue / 65535) * 360),
          s: Math.floor((currentSaturation / 65535) * 100),
          v: Math.floor((currentValue / 65535) * 100),
        }
      }else{
        currentColor = {
          h: 0,
          s: 0,
          v: 0,
        }
      }
      return currentColor;
    },
    currentWhite: function () {
      var currentWhite = this.$store.getters.getParameterValue(this.node.index, NODE9.WHITE.PARAMETER_ID);
      if(currentWhite !== undefined){
        currentWhite = Math.floor((currentWhite / 65535) * 100);
      }else{
        currentWhite = 65535;
      }
      return currentWhite;
    },
    isNodeOffline: function () {
      if(this.node.connectionStatus == 1){
        return false;
      }else{
        return true;
      }
    },
    isHubOffline: function () {
      if(this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2){
        return false;
      }else{
        return true;
      }
    },
    dropDownColorPickerType: function () {
      var dropDownColorPickerType = {
        name: "Node9Settings-ColorPickerType",
        title: this.$store.getters.language.texts.Node9Settings_colorPickerType,
        selectedIndex: this.colorPickerType,
        data: [
          {
            name: 'HS+V',
            icon: 'rgb',
          },
          {
            name: 'H+SV',
            icon: 'rgb',
          },
          {
            name: 'Kelvin',
            icon: 'rgb',
          },
        ]
      };
      return dropDownColorPickerType;
    },
    dropDownAnimationMode: function () {
      var dropDownColorPickerType = {
        name: "Node9Settings-ColorPickerType",
        title: this.$store.getters.language.texts.Node9Settings_animation,
        selectedIndex: this.animationMode,
        data: [
          {
            name: this.$store.getters.language.texts.Node9Settings_animation0,
            icon: 'disabled',
          },
          {
            name: this.$store.getters.language.texts.Node9Settings_animation1,
            icon: 'randomColor',
          },
          {
            name: this.$store.getters.language.texts.Node9Settings_animation2,
            icon: 'rgb',
          },
        ]
      };
      return dropDownColorPickerType;
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    isBoxActive: function (boxIndex) {
      if(this.activeBoxIndex == boxIndex) {
        return 'active';
      }else{
        return '';
      }
    },
    deleteDevice: function () {
      this.$router.push('/DeleteDevice/' + this.node.uuid);
    },
    onColorChange: function (color) {
      if(!this.colorLocked){
        this.colorLocked = true;
        this.colorPicker_r.color.hsv = {
          h: 0,
          s: 100,
          v: Math.floor((color.rgb.r / 255) * 100),
        }
        this.colorPicker_g.color.hsv = {
          h: 120,
          s: 100,
          v: Math.floor((color.rgb.g / 255) * 100),
        }
        this.colorPicker_b.color.hsv = {
          h: 240,
          s: 100,
          v: Math.floor((color.rgb.b / 255) * 100),
        }
        this.colorLocked = false;
        clearTimeout(this.colorChangeTimeoutHandle);
        this.colorChangeTimeoutHandle = setTimeout( async () => {
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: false,
          });
          this.color.hue = Math.floor((color.hsv.h / 360) * 65535);
          this.color.saturation = Math.floor((color.hsv.s / 100) * 65535);
          //Math.min is due to a bug in iro.js causing value to be more than 100!
          this.color.value = Math.floor(( Math.min(color.hsv.v, 100) / 100) * 65535);

          var messagingHook = new Messaging(new Logger(false));
          messagingHook.init({
            psk: this.hub.psk,
            destinationUUID: this.hub.uuid,
            sourceUUID: this.$store.state.user.uuid
          });
          try {
            await this.$store.dispatch('setNodesParameters', {
              messagingHook: messagingHook,
              hubUUID: this.hub.uuid,
              nodeUUID: this.node.uuid,
              bodyContent: {
                nodeActions: [
                  {
                    nodeUUID: this.node.uuid,
                    actions: [
                      {
                        parameterId: NODE9.ANIMATION_MODE.PARAMETER_ID,
                        valueOfChange: CONFIGS.RGBW_ANIMATION_NONE,
                        typeOfAction: CONFIGS.ACTION_TYPE_SET,
                        timeDelay: 0
                      },
                      {
                        parameterId: NODE9.HUE.PARAMETER_ID,
                        valueOfChange: this.color.hue,
                        typeOfAction: CONFIGS.ACTION_TYPE_SET,
                        timeDelay: 0
                      },
                      {
                        parameterId: NODE9.SATURATION.PARAMETER_ID,
                        valueOfChange: this.color.saturation,
                        typeOfAction: CONFIGS.ACTION_TYPE_SET,
                        timeDelay: 0
                      },
                      {
                        parameterId: NODE9.BRIGHTNESS.PARAMETER_ID,
                        valueOfChange: this.color.value,
                        typeOfAction: CONFIGS.ACTION_TYPE_SET,
                        timeDelay: 0
                      },
                    ]
                  },
                ]
              }
            })
            //showing the user that animation is not active
            this.animationMode = 0;
            console.log("DONE");
          }
          catch (response) {
            console.log(response);
            if(response.rejectCode == 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }
          }
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: true,
          });
        }, this.debounceDelay);
      }
    },
    onColorChange_w: function (color) {
      if(!this.colorLocked){
        clearTimeout(this.colorChangeTimeoutHandle);
        this.colorChangeTimeoutHandle = setTimeout( async () => {
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: false,
          });
          this.white = Math.floor((color.hsv.v / 100) * 65535);

          var messagingHook = new Messaging(new Logger(false));
          messagingHook.init({
            psk: this.hub.psk,
            destinationUUID: this.hub.uuid,
            sourceUUID: this.$store.state.user.uuid
          });
          try {
            await this.$store.dispatch('setNodesParameters', {
              messagingHook: messagingHook,
              hubUUID: this.hub.uuid,
              nodeUUID: this.node.uuid,
              bodyContent: {
                nodeActions: [
                  {
                    nodeUUID: this.node.uuid,
                    actions: [
                      {
                        parameterId: NODE9.WHITE.PARAMETER_ID,
                        valueOfChange: this.white,
                        typeOfAction: CONFIGS.ACTION_TYPE_SET,
                        timeDelay: 0
                      },
                    ]
                  },
                ]
              }
            })
            console.log("DONE_W");
          }
          catch (response) {
            console.log(response);
            if(response.rejectCode == 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }
          }
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: true,
          });
        }, this.debounceDelay);
      }
    },
    onColorChange_r: function (color) {
      if(!this.colorLocked){
        this.colorPicker.color.setChannel('rgb', 'r', Math.min(Math.floor((color.hsv.v / 100) * 255)), 100);
      }
    },
    onColorChange_g: function (color) {
      if(!this.colorLocked){
        this.colorPicker.color.setChannel('rgb', 'g', Math.min(Math.floor((color.hsv.v / 100) * 255)), 100);
      }
    },
    onColorChange_b: function (color) {
      if(!this.colorLocked){
        this.colorPicker.color.setChannel('rgb', 'b', Math.min(Math.floor((color.hsv.v / 100) * 255)), 100);
      }
    },
    setAnimation: async function (animationType) {
      return new Promise( async (resolve, reject) => {
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: false,
        });
        var messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: this.hub.psk,
          destinationUUID: this.hub.uuid,
          sourceUUID: this.$store.state.user.uuid
        });
        try {
          await this.$store.dispatch('setNodesParameters', {
            messagingHook: messagingHook,
            hubUUID: this.hub.uuid,
            nodeUUID: this.node.uuid,
            bodyContent: {
              nodeActions: [
                {
                  nodeUUID: this.node.uuid,
                  actions: [
                    {
                      parameterId: NODE9.SATURATION.PARAMETER_ID,
                      valueOfChange: 65535,
                      typeOfAction: CONFIGS.ACTION_TYPE_SET,
                      timeDelay: 0
                    },
                    {
                      parameterId: NODE9.ANIMATION_MODE.PARAMETER_ID,
                      valueOfChange: animationType,
                      typeOfAction: CONFIGS.ACTION_TYPE_SET,
                      timeDelay: 0
                    },
                  ]
                },
              ]
            }
          })
          console.log("DONE_Animation");
        }
        catch (response) {
          console.log(response);
          reject(response);
        }
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: true,
        });
        resolve();
      });
    },
    setFadeTime: async function (fadeTime) {
      return new Promise( async (resolve, reject) => {
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: false,
        });
        var messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: this.hub.psk,
          destinationUUID: this.hub.uuid,
          sourceUUID: this.$store.state.user.uuid
        });
        try {
          await this.$store.dispatch('setNodesParameters', {
            messagingHook: messagingHook,
            hubUUID: this.hub.uuid,
            nodeUUID: this.node.uuid,
            bodyContent: {
              nodeActions: [
                {
                  nodeUUID: this.node.uuid,
                  actions: [
                    {
                      parameterId: NODE9.FADE_TIME.PARAMETER_ID,
                      valueOfChange: fadeTime,
                      typeOfAction: CONFIGS.ACTION_TYPE_SET,
                      timeDelay: 0
                    },
                  ]
                },
              ]
            }
          })
          console.log("DONE_FadeTime");
        }
        catch (response) {
          console.log(response);
          reject(response);
        }
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: true,
        });
        resolve();
      });
    },
    setAsDefaultColor: async function () {
      this.$store.commit('setAppBusy', true);
      this.$store.commit('setHubStatus', {
        hubIndex: this.hub.index,
        stateUpdateEnabled: false,
      });

      this.color.hue = Math.floor((this.colorPicker.color.hsv.h / 360) * 255);
      this.color.saturation = Math.floor((this.colorPicker.color.hsv.s / 100) * 255);
      this.color.value = Math.floor((this.colorPicker.color.hsv.v / 100) * 255);
      this.color.white = Math.floor((this.colorPicker_w.color.hsv.v / 100) * 255);
      
      var initcolor =  (this.color.value << 8) + (this.color.saturation << 16) + (this.color.hue << 24);

      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: this.hub.psk,
        destinationUUID: this.hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });
      try {
        await this.$store.dispatch('setNodesParameters', {
          messagingHook: messagingHook,
          hubUUID: this.hub.uuid,
          nodeUUID: this.node.uuid,
          bodyContent: {
            nodeActions: [
              {
                nodeUUID: this.node.uuid,
                actions: [
                  {
                    parameterId: NODE9.RGBW_INIT.PARAMETER_ID,
                    valueOfChange: initcolor,
                    typeOfAction: CONFIGS.ACTION_TYPE_SET,
                    timeDelay: 0
                  },
                ]
              },
            ]
          }
        })
        console.log("DONE_init");
      }
      catch (response) {
        console.log(response);
        if(response.rejectCode == 2){
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
      }
      this.$store.commit('setHubStatus', {
        hubIndex: this.hub.index,
        stateUpdateEnabled: true,
      });
      this.$store.commit('setAppBusy', false);
    },
    saveChanges: async function () {
      var errorHappened = false;
      this.inputState = '';
      if(this.NodeName == ''){
        this.inputState = 'error';
        alert(this.$store.getters.language.texts.Node2Settings_alert);
      }else{
        this.$store.commit('setAppBusy', true);
        this.$store.commit('setNodeName', {nodeIndex: this.node.index, name: this.NodeName})
        this.$store.commit('setNodeColor', {nodeIndex: this.node.index, color: this.activeBoxIndex})
        this.$store.commit('saveState');
        if(!this.isNodeOffline && !this.isHubOffline){
          if(this.animationMode != this.currentAnimationMode){
            try {
             await this.setAnimation(this.animationMode); 
            } catch (response) {
              if(response.rejectCode == 1){
                this.$router.push('/SettingsNodeError');
              }else if(response.rejectCode == 2){
                this.$router.push('/SettingsHubError');
                this.$store.commit('setHubStatus', {
                  hubIndex: response.hubIndex,
                  connectionStatus: {
                    local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                    online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  },
                });
              }else{
                this.$router.push('/SettingsHubError');
              }
              errorHappened = true;
              this.$store.commit('setAppBusy', false);
            }
          }
          if(errorHappened){
            return;
          }
          if(this.fadeTime != this.currentFadeTime){
            try {
             await this.setFadeTime(this.fadeTime); 
            } catch (response) {
              if(response.rejectCode == 1){
                this.$router.push('/SettingsNodeError');
              }else if(response.rejectCode == 2){
                this.$router.push('/SettingsHubError');
                this.$store.commit('setHubStatus', {
                  hubIndex: response.hubIndex,
                  connectionStatus: {
                    local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                    online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  },
                });
              }else{
                this.$router.push('/SettingsHubError');
              }
              errorHappened = true;
              this.$store.commit('setAppBusy', false);
            }
          }
          if(errorHappened){
            console.log('here');
            return;
          }
          this.$router.push('/Home/Devices');
          this.$store.commit('setAppBusy', false);
        }else{
          this.$router.push('/Home/Devices');
          this.$store.commit('setAppBusy', false);
        }
      }
    },
  }
}
</script>

<style>
  .Node9Settings-topCurve-wrapper {
    height: 200px;
  }
  .Node9Settings-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .Node9Settings-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .Node9Settings-wrapper-colors {
    height: 50px;
  }
  .Node9Settings-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .Node9Settings-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .Node9Settings-color.active .Node9Settings-selectedColor {
    opacity: 1;
  }
  .Node9Settings-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .Node9Settings-wrapper-name-text {
    height: 50px;
    padding-top: 20px;
    line-height: 30px;
    color: #52626C;
  }
  .Node9Settings-wrapper-deviceName {
    height: 30px;
    line-height: 30px;
    color: #53636C;
  }
  .Node9Settings-wrapper-UUID {
    height: 30px;
    color: #53636C;
    margin-top: 14px;
  }
  .Node9Settings-wrapper-UUID-d0 {
    letter-spacing: 2px;
    line-height: 30px;
  }
  .Node9Settings-wrapper-UUID-d1 {
    letter-spacing: 3px;
    line-height: 30px;
  }
  .Node9Settings-wrapper-status {
    height: 50px;
    margin-top: 14px;
  }
  .Node9Settings-wrapper-status-d0 {
    line-height: 50px;
  }
  .Node9Settings-wrapper-status-d1 {
    padding-top: 5px;
    margin-right: 10px;
  }
  .Node9Settings-wrapper-button {
    width: calc(100% - 36px);
    margin-top: 14px;
    margin-bottom: 14px;
  }
  .Node9Settings-wrapper-fieldTitles {
    margin-top: 10px;
    height: 20px;
    line-height: 20px;
    color: #52626C;
  }
</style>
